// 看料门 · 热点资讯与围观热议数据

export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: "现场直击", href: "#home" },
  { label: "热议前线", href: "#feed" },
  { label: "栏目分类", href: "#columns" },
  { label: "热度榜", href: "#rank" },
  { label: "前排围观", href: "#crowd" },
  { label: "主题专区", href: "#zones" },
  { label: "关于我们", href: "#about" },
];

export interface TickerItem {
  id: number;
  text: string;
  heat: string;
}

export const tickerItems: TickerItem[] = [
  { id: 1, text: "今日讨论风向：主打一个“晒”与“回怼”的对垒", heat: "热 128.6万" },
  { id: 2, text: "前排围观群众已达 31.2 万人，座位持续加急", heat: "爆 86.4万" },
  { id: 3, text: "某综艺神级名场面刷屏，网友：已在现场前排就坐", heat: "热 64.1万" },
  { id: 4, text: "一条热梗带火整条赛道，评论区已吵成一锅粥", heat: "热 47.9万" },
  { id: 5, text: "复盘与澄清齐飞，围观群众直呼“这瓜保熟”", heat: "新 39.3万" },
  { id: 6, text: "反转连续剧上线，热度榜前三再次大洗牌", heat: "爆 58.7万" },
];

export interface Category {
  name: string;
  icon: string;
  desc: string;
  count: string;
  cover: string;
}

export const categories: Category[] = [
  {
    name: "娱乐吃瓜",
    icon: "ri-mic-2-line",
    desc: "综艺名场面、晚会名场面与艺能话题的第一现场",
    count: "1.2万条",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20a%20glowing%20stage%20spotlight%20with%20confetti%20in%20the%20air%20above%20an%20audience%2C%20documentary%20concert%20photography%2C%20amber%20and%20cream%20tone%2C%20cinematic%20depth%2C%20soft%20bokeh&width=900&height=700&seq=cat-ent-01&orientation=portrait",
  },
  {
    name: "影视名场",
    icon: "ri-film-line",
    desc: "剧集热播、评分口碑与高能片段逐帧复盘",
    count: "8600条",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20film%20set%20with%20a%20clapperboard%20and%20golden%20theater%20lighting%2C%20behind%20the%20scenes%20documentary%20style%2C%20cream%20and%20terracotta%20palette%2C%20shallow%20depth%20of%20field&width=900&height=700&seq=cat-film-02&orientation=portrait",
  },
  {
    name: "科技热闻",
    icon: "ri-cpu-line",
    desc: "新机发布、AI 新玩法与互联网热梗科普",
    count: "5300条",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20still%20life%20of%20modern%20tech%20gadgets%20on%20a%20cream%20desk%20with%20warm%20window%20light%2C%20minimalist%20photography%2C%20soft%20shadows%2C%20amber%20neutral%20tone&width=900&height=700&seq=cat-tech-03&orientation=portrait",
  },
  {
    name: "社会热议",
    icon: "ri-global-line",
    desc: "民生话题、公共议题与现象级讨论的方向标",
    count: "6900条",
    cover: "https://readdy.ai/api/search-image?query=Warm%20street%20photography%20of%20a%20crowd%20of%20people%20in%20the%20city%20under%20golden%20hour%20light%2C%20documentary%20style%2C%20cream%20and%20amber%20tone%2C%20candid%20moment&width=900&height=700&seq=cat-social-04&orientation=portrait",
  },
  {
    name: "生活话题",
    icon: "ri-cup-line",
    desc: "生活方式、消费吐槽与普通人身边的热闹事",
    count: "4200条",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cozy%20editorial%20photo%20of%20a%20coffee%20cup%20and%20notebook%20on%20a%20sunlit%20cream%20table%20beside%20a%20window%2C%20lifestyle%20photography%2C%20soft%20natural%20light%2C%20earthy%20warm%20tone&width=900&height=700&seq=cat-life-05&orientation=portrait",
  },
  {
    name: "体坛速递",
    icon: "ri-trophy-line",
    desc: "赛场高光、爆冷瞬间与球迷前排热评速递",
    count: "3100条",
    cover: "https://readdy.ai/api/search-image?query=Warm%20sports%20editorial%20photo%20of%20a%20stadium%20floodlight%20and%20a%20trophy%20in%20silhouette%2C%20evening%20golden%20tone%2C%20documentary%20style%2C%20dramatic%20light&width=900&height=700&seq=cat-sport-06&orientation=portrait",
  },
];

export interface Article {
  id: string;
  category: string;
  title: string;
  summary: string;
  time: string;
  heat: string;
  comments: number;
  author: string;
  tag: string;
  cover: string;
  featured?: boolean;
}

export const articles: Article[] = [
  {
    id: "n01",
    category: "娱乐吃瓜",
    title: "一场直播名场面如何刷爆全网：从“神级救场”到全民二创",
    summary: "从晚会现场的一个临场反应说起，看主持人与嘉宾如何在一分钟内完成教科书级救场，随后引发全民二次创作，讨论风向一路走高。",
    time: "8分钟前",
    heat: "128.6万",
    comments: 48213,
    author: "现场君",
    tag: "现场直击",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20photography%20of%20a%20glowing%20stage%20with%20spotlights%20and%20an%20excited%20live%20audience%20raising%20hands%2C%20concert%20documentary%20style%2C%20amber%20and%20cream%20palette%2C%20dynamic%20atmosphere&width=1200&height=760&seq=news-a-01&orientation=landscape",
    featured: true,
  },
  {
    id: "n02",
    category: "社会热议",
    title: "“晒图回怼”成新风潮：当代网友都在评论区里怎么玩",
    summary: "继“接龙”“空耳”之后，一种把实物照片拍成段子的回怼玩法正在扩散，我们拆解了这股风潮的走红路径与传播逻辑。",
    time: "26分钟前",
    heat: "86.4万",
    comments: 35607,
    author: "风向老哥",
    tag: "热议中",
    cover: "https://readdy.ai/api/search-image?query=Warm%20street%20documentary%20photo%20of%20people%20taking%20photos%20with%20phones%20in%20a%20lively%20city%20plaza%20during%20golden%20hour%2C%20candid%2C%20amber%20neutral%20tone&width=1200&height=760&seq=news-b-02&orientation=landscape",
    featured: true,
  },
  {
    id: "n03",
    category: "科技热闻",
    title: "一条热梗如何带火整条赛道：AI 工具圈最近的出圈密码",
    summary: "从某款 AI 助手被网友玩出“十万种用法”，到工具出海成为流量新宠，我们聊聊热梗背后的产品逻辑与围观热情。",
    time: "41分钟前",
    heat: "64.1万",
    comments: 22109,
    author: "前排君",
    tag: "新鲜出炉",
    cover: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20editorial%20photo%20of%20a%20laptop%20screen%20glowing%20with%20abstract%20soft%20orange%20interface%20on%20a%20cream%20desk%2C%20modern%20tech%2C%20soft%20shadows&width=1200&height=760&seq=news-c-03&orientation=landscape",
  },
  {
    id: "n04",
    category: "影视名场",
    title: "评分逆袭背后：这部冷门剧靠“细节控”硬生生把口碑盘活",
    summary: "没有顶流加持，却靠服化道细节和剪辑节奏层层递进，观众从“随手点开”到“安利成团”，这场口碑逆袭值得细看。",
    time: "1小时前",
    heat: "58.7万",
    comments: 19873,
    author: "逐帧组",
    tag: "口碑黑马",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20still%20of%20a%20film%20production%20scene%20with%20vintage%20lamps%20and%20a%20director%20chair%2C%20amber%20cream%20color%20grading%2C%20editorial%20film%20magazine%20style&width=1200&height=760&seq=news-d-04&orientation=landscape",
  },
  {
    id: "n05",
    category: "娱乐吃瓜",
    title: "晚会“出圈名场面”盘点：这些瞬间为何让人反复倒回去看",
    summary: "从舞台机关到临场互动，年度最让人忍不住二刷的高光片段逐帧复盘，围观群众前排直呼“这波操作有点东西”。",
    time: "2小时前",
    heat: "53.2万",
    comments: 17321,
    author: "名场面组",
    tag: "现场直击",
    cover: "https://readdy.ai/api/search-image?query=Warm%20stage%20lighting%20photo%20of%20a%20performer%20silhouette%20under%20golden%20beams%20with%20light%20rays%20and%20dust%20particles%2C%20dramatic%20theater%2C%20amber%20tone&width=1200&height=760&seq=news-e-05&orientation=landscape",
  },
  {
    id: "n06",
    category: "生活话题",
    title: "“搭子文化”热过之后，年轻人又在评论区整出了哪些新活",
    summary: "从饭搭子、考搭子到现在的“情绪围观”，年轻人正在把每一次日常小事都变成一场有人气的线上茶话会。",
    time: "3小时前",
    heat: "47.9万",
    comments: 15210,
    author: "生活研究员",
    tag: "热议中",
    cover: "https://readdy.ai/api/search-image?query=Warm%20lifestyle%20editorial%20photo%20of%20friends%20chatting%20and%20laughing%20around%20a%20cream%20table%20with%20tea%20and%20snacks%2C%20cozy%20golden%20light%2C%20documentary%20feel&width=1200&height=760&seq=news-f-06&orientation=landscape",
  },
  {
    id: "n07",
    category: "体坛速递",
    title: "爆冷之夜全复盘：赛前不被看好的他们如何完成极限翻盘",
    summary: "数据不会说谎，但奇迹从不看数据脸色。我们还原这场载入热搜的翻盘全过程，以及球迷前排的激情时刻。",
    time: "4小时前",
    heat: "39.3万",
    comments: 11094,
    author: "看台记者",
    tag: "高光时刻",
    cover: "https://readdy.ai/api/search-image?query=Warm%20evening%20stadium%20photo%20of%20an%20athlete%20celebrating%20under%20golden%20floodlights%20with%20crowd%20cheering%20in%20blur%2C%20sports%20documentary%2C%20amber%20tone&width=1200&height=760&seq=news-g-07&orientation=landscape",
  },
  {
    id: "n08",
    category: "科技热闻",
    title: "从“看不懂”到“抢着学”：AI 新词汇正在被围观群众带火",
    summary: "当专业术语被翻译成“人话”并配上好玩的表情包，技术门槛瞬间被融化，一场关于新事物的围观式科普正在进行。",
    time: "5小时前",
    heat: "35.1万",
    comments: 9803,
    author: "科普前排",
    tag: "新鲜出炉",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20open%20books%20and%20a%20glowing%20tablet%20on%20a%20cream%20table%20with%20morning%20sunlight%2C%20study%20vibe%2C%20soft%20amber%20tone&width=1200&height=760&seq=news-h-08&orientation=landscape",
  },
  {
    id: "n09",
    category: "社会热议",
    title: "“情绪价值”成为年度热词：这届网友把什么聊成了新刚需",
    summary: "从职场到家庭，从追星到上网，“提供情绪价值”正在成为被频繁讨论的关键词，背后是年轻人表达方式的集体变化。",
    time: "6小时前",
    heat: "31.8万",
    comments: 8702,
    author: "风向老哥",
    tag: "热议中",
    cover: "https://readdy.ai/api/search-image?query=Warm%20documentary%20photo%20of%20a%20group%20of%20young%20people%20having%20an%20animated%20conversation%20in%20a%20warm%20cafe%2C%20golden%20window%20light%2C%20candid%20editorial%20feel&width=1200&height=760&seq=news-i-09&orientation=landscape",
  },
];

export interface RankItem {
  id: number;
  title: string;
  category: string;
  heat: string;
  change: number; // 正为上升 负为下降 0为持平
}

export const rankItems: RankItem[] = [
  { id: 1, title: "一场直播名场面刷屏，全民开启二创接力", category: "娱乐吃瓜", heat: "1286.4万", change: 1 },
  { id: 2, title: "“晒图回怼”新玩法让评论区热闹翻了", category: "社会热议", heat: "986.1万", change: 3 },
  { id: 3, title: "冷门剧靠细节逆袭口碑，安利大军就位", category: "影视名场", heat: "845.7万", change: -1 },
  { id: 4, title: "AI 新工具爆火，围观群众排队求同款", category: "科技热闻", heat: "712.3万", change: 2 },
  { id: 5, title: "爆冷之夜翻盘全复盘引发球迷集体回忆", category: "体坛速递", heat: "603.9万", change: 0 },
  { id: 6, title: "“搭子文化”后年轻人在整新活", category: "生活话题", heat: "521.4万", change: 4 },
  { id: 7, title: "情绪价值成年度热词，讨论持续升温", category: "社会热议", heat: "436.8万", change: 2 },
  { id: 8, title: "晚会名场面盘点，反复倒回去看的那种", category: "娱乐吃瓜", heat: "378.2万", change: -3 },
];

export interface CommentItem {
  id: number;
  nickname: string;
  avatarColor: string;
  text: string;
  likes: number;
  replies: number;
  position: string;
}

export const commentItems: CommentItem[] = [
  { id: 1, nickname: "西瓜摊主", avatarColor: "primary", text: "本来只是想随手刷一眼，结果一个名场面循环了三遍，这瓜是真保熟。", likes: 8621, replies: 314, position: "沙发 · 4楼" },
  { id: 2, nickname: "前排小板凳", avatarColor: "accent", text: "建议直接出连续剧，反转一个接一个，我已经瓜子饮料都备好了。", likes: 7543, replies: 268, position: "板凳 · 8楼" },
  { id: 3, nickname: "熬夜吃瓜人", avatarColor: "secondary", text: "评论区比正文还精彩，翻到第两百楼看到个神评论，差点没憋住笑。", likes: 6310, replies: 205, position: "地摊 · 12楼" },
  { id: 4, nickname: "围观不插嘴", avatarColor: "primary", text: "保持围观看风向，这波讨论角度挺多元，理性派和玩梗派都有道理。", likes: 4827, replies: 141, position: "长椅 · 16楼" },
  { id: 5, nickname: "瓜子预备役", avatarColor: "accent", text: "搬好小板凳占个前排，今天的热度榜前三绝对要洗牌。", likes: 3509, replies: 98, position: "顶楼 · 19楼" },
];

export interface HotTopic {
  id: number;
  text: string;
  heat: string;
  up: number;
}

export const heroHotTopics: HotTopic[] = [
  { id: 1, text: "名场面二创接力", heat: "1286万", up: 12 },
  { id: 2, text: "晒图回怼新玩法", heat: "986万", up: 8 },
  { id: 3, text: "冷门剧口碑逆袭", heat: "845万", up: 5 },
  { id: 4, text: "AI 工具出圈", heat: "712万", up: 9 },
];

export interface TopicZone {
  id: number;
  label: string;
  title: string;
  desc: string;
  stat: string;
  cover: string;
}

export const topicZones: TopicZone[] = [
  {
    id: 1,
    label: "专题 · 名场面",
    title: "那些被反复刷屏的高光时刻",
    desc: "从晚会现场到影视剪辑，我们把今年最能“上头”的名场面逐帧拆给你看，前排视角带你重回第一现场。",
    stat: "已收录 326 个名场面",
    cover: "https://readdy.ai/api/search-image?query=Warm%20dramatic%20stage%20with%20layered%20golden%20curtains%20and%20spotlight%20beams%20cutting%20through%20haze%2C%20cinematic%20editorial%2C%20amber%20cream%20palette&width=1400&height=760&seq=zone-a-01&orientation=landscape",
  },
  {
    id: 2,
    label: "专题 · 风向",
    title: "这届网友的快乐哲学",
    summary: "",
    desc: "搭子、回怼、情绪围观、反向安利……我们在盘点年轻人那些“你一句我一句”就能玩一天的互联网新玩法与讨论风向。",
    stat: "已收录 178 个热梗",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20collage%20of%20sticky%20notes%20laptop%20and%20colored%20markers%20on%20a%20sunlit%20cream%20desk%2C%20creative%20youth%20energy%2C%20amber%20neutral%20tone&width=1400&height=760&seq=zone-b-02&orientation=landscape",
  },
  {
    id: 3,
    label: "专题 · 复盘",
    title: "反转来了又来了：年度连续剧大赏",
    desc: "从不被看好到极限翻盘，从众说纷纭到尘埃落定，我们把几场公认的“反转连续剧”完整还原，看过程也看态度。",
    stat: "已收录 96 个反转事件",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20photo%20of%20a%20vintage%20movie%20projector%20beam%20and%20film%20reels%20in%20a%20dark%20room%2C%20amber%20glow%2C%20editorial%20retro%20tone&width=1400&height=760&seq=zone-c-03&orientation=landscape",
  },
];

export interface ReviewItem {
  id: number;
  name: string;
  role: string;
  text: string;
  stars: number;
}

export const reviewItems: ReviewItem[] = [
  { id: 1, name: "早八吃瓜王", role: "围观三年老粉", text: "基本每天早上一睁眼就来看料门刷风向，总结得又全又清楚，连评论区里的神回复都给你翻出来了，省心。", stars: 5 },
  { id: 2, name: "隔壁老陈", role: "偶尔前排用户", text: "热度榜做得挺客观，涨跌都标清楚，晚一点也有一手复盘，比自己在各平台来回跳强太多。", stars: 5 },
  { id: 3, name: "夜宵配瓜", role: "吃瓜新人", text: "刚注册没几天，栏目分得很细，想看什么类型直接点，字幕氛围也到位，已经安利给好几个朋友了。", stars: 5 },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "看料门的内容是怎么来的？",
    a: "看料门聚焦全网公开可见的热议话题与公开传播信息，由编辑部按“现场直击、风向复盘、理性吃瓜”的原则筛选、核实与整理，让围观群众能在一处看完来龙去脉与不同观点。",
  },
  {
    q: "“现场直击”和普通资讯有什么区别？",
    a: "现场直击更强调围观视角与时效：我们会把事件的时间线、关键节点、各方反应与代表性评论区声音一起呈现，帮助你不只看结论，也能看懂讨论为何会这样发酵。",
  },
  {
    q: "我看到的热度值是怎么算出来的？",
    a: "热度值综合了公开讨论量、传播增速与话题持续时间等多个维度，并在时段内动态更新。它只反映“被讨论的程度”，不代表对事件本身的定性判断。",
  },
  {
    q: "我能在看料门投稿或纠错吗？",
    a: "当然可以。你在“关于我们”或页面底部留言都能联系到编辑部，我们欢迎有价值的线索、有趣的围观视角，也欢迎大家对事实层面的出入提出纠正，核实后会及时更新。",
  },
];